<template>
    <div class="layout">
        <div id="layout-title">
            <div id="layout-title-left">
                <img src="/static/imgs/jiaose.png" class="jxyd-imgicon" />
                角色管理
            </div>
            <div id="layout-title-right">
                <button class="jxyd-button" title="新建角色" @click="addRole" style="margin-right:10px;" v-show="permission.isAdd">
                    <Icon type="md-add-circle" size='18'/> 新建
                </button>
                <button class="jxyd-button" title="删除角色" @click="deleteRole" v-show="permission.isDelete">
                    <Icon type="md-trash" size='18'/> 删除
                </button>
            </div>
        </div>
        <div id="layout-box">
            <div id="box-search">
                <Form ref="formSearch" :model="searchItems" inline>
                    <FormItem>
                        <Input type="text" v-model="searchItems.roleName" placeholder="角色名" @keyup.enter.native="initListData(1)" />
                    </FormItem>
                    <FormItem>
                        <button class="jxyd-button jxyd-primary" @click="initListData(1)">查询</button>
                    </FormItem>
                </Form>
            </div>
            <div id="box-table">
                <Table ref="roleList" :columns="tableColumns" :data="roleData" @on-selection-change="roleListSeleChange"></Table>
            </div>
            <div id="page-box">
                <Page :total="roleCount" :page-size="searchItems.pageSize"
                      @on-change="pageChange" show-total
                      :current="searchItems.pageIndex"
                      style="display:inline-block;">
                </Page>
            </div>
        </div>

        <Modal v-model="modalDisPlay" draggable sticky scrollable>
            <p slot="header" class="modal-header">
                <img src="/static/imgs/bianjiyonghu.png" class="jxyd-imgicon" />
                <span> 操作角色</span>
            </p>
            <div style="background-color:#fff;padding:20px;border-radius:5px;">
                <Form ref="formRole" :model="formItem" :label-width="70" :rules="ruleRole">

                    <Form-item label="角色名" prop="roleName">
                        <Input v-model="formItem.roleName" placeholder="请输入" size="large" />
                    </Form-item>
                    <Form-item label="是否启用">
                        <i-Switch v-model="formItem.isUse" size="large" />
                    </Form-item>
                    <Form-item label="备注" prop="note">
                        <Input v-model="formItem.note" type="textarea" placeholder="请输入" size="large" />
                    </Form-item>
                </Form>
            </div>
            <div slot="footer">
                <button class="jxyd-button" @click="cancel('formRole')">取消</button>
                <button class="jxyd-button jxyd-primary" @click="roleSubmit('formRole')">保存</button>
            </div>
        </Modal>

        <Modal v-model="modalUser" draggable sticky scrollable>
            <p slot="header" class="modal-header">
                <img src="/static/imgs/guanlirenyuan.png" class="jxyd-imgicon" />
                <span> 管理人员</span>
            </p>
            <div style="background-color:#fff;border-radius:5px;">
                <div style="padding:25px;">
                    <userList ref="userList" :selectedUsers="selectedUsers"></userList>
                </div>
            </div>
            <div slot="footer">
                <button class="jxyd-button" @click="modalUser = false;">取消</button>
                <button class="jxyd-button jxyd-primary" @click="userItemSubmit">保存</button>
            </div>
        </Modal>


        <Modal v-model="modalFunc" width="1000" draggable sticky scrollable>
            <p slot="header" class="modal-header">
                <img src="/static/imgs/shezhi.png" class="jxyd-imgicon" />
                <span> 管理功能项</span>
            </p>
            <div style="height:600px;overflow:auto;">
                <div v-for="(item,index) in treeData" :key='index'>
                	<div class="func-modal">
                		<div class="func-modal-title">
                			<div class='func-modal-title-left'>
                				<Checkbox @on-change='firstLevelClick(item)' v-model="item.checked">
                				</Checkbox>
                				{{item.title}}
                			</div>
                			<div class="func-modal-title-right" @click="selectedAll(item)">
                				<a class="jxyd-a">全选</a>
                			</div>
                		</div>
                		<div class="func-modal-content">
                			<div class="box" v-for="(item2,index2) in item.children" :key='index2'>
                				<div class="box-head">
                					<div class="box-head-title">
                						<Checkbox v-model="item2.checked"
                							@on-change="secondLevelClick(item2)" />{{item2.title}}
                					</div>
                					<div class="box-head-title-tool" @click="selectedAll(item2)">
                						<a class="jxyd-a">全选</a>
                					</div>
                				</div>
                				<div class="box-body">
                					<div v-for="(item3,index3) in item2.function" :key='index3'
                						class="box-body-item">
                						<Checkbox @on-change="thirdLevelClick(item3)" v-model="item3.checked"/>
                						<span>
                							{{item3.name}}
                						</span>
                					</div>
                				</div>
                			</div>
                		</div>
                	</div>
                </div>
            </div>

            <div slot="footer">
                <button class="jxyd-button" @click="modalFunc = false;">取消</button>
                <button class="jxyd-button jxyd-primary" @click="menuItemSubmit">保存</button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import userList from '@/views/SystemManage/userList'

    export default {
        name: 'rolemanage',
        components: {
            userList
        },
        data() {
            return {
                searchItems: {
                    roleName: '',
                    pageSize: 11,
                    pageIndex: 1,
                },
                roleRowId:0,
                roleCount: 0,
                modalDisPlay: false,
                modalUser: false,
                modalFunc:false,
                tableColumns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '角色名',
                        key: 'roleName'
                    },
                    {
                        title: '是否启用',
                        key: 'isUse',
                        render: (h,params) => {
                            return h('i-Switch', {
                                attrs: {
                                    'value': params.row.isUse,
                                    'disabled': !this.permission.isUpdateUse
                                },
                                on: {
                                    'on-change': (e) => {
                                        params.row.isUse = e;
                                        let self = this;
                                        let tag = '';
                                        if (e) {
                                            tag = '启用';
                                        } else {
                                            tag = '停用';
                                        }
                                        this.$Modal.confirm({
                                            title: "操作警告",
                                            content: "是否确认" + tag + "“" + params.row.roleName + "”角色？",
                                            onOk() {
                                                request.get('/api/Role/EditUse', {
                                                    params: {
                                                        id: params.row.id,
                                                        isUse: e
                                                    }
                                                }).then(function (response) {
                                                    if (response.state == 0) {
                                                        self.$Notice.error({
                                                            title: '错误提示',duration: 3,
                                                            desc: '更新失败:' + response.errorMsg
                                                        });
                                                        return;
                                                    }
                                                    self.$Notice.success({
                                                        title: '正确提示',duration: 3,
                                                        desc: '更新成功!'
                                                    });
                                                }).catch(function (error) {
                                                    params.row.isUse = !e;
                                                })
                                            },
                                            onCancel() {
                                                params.row.isUse = !e;
                                            }
                                        });
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: '备注',
                        key: 'note'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 200,
                        align: 'center',
                        fixed: 'right',
                        render: (h, params) => {
                            let funcList = [];
                            if (this.permission.isEdit) {
                                funcList.push(h('i-button', {
                                    style: {
                                        'margin-right': '5px'
                                    },
                                    attrs: {
                                        type: `primary`,
                                        class: "ivu-btn ivu-btn-primary ivu-btn-small"
                                    },
                                    on: {
                                        click: (e) => {
                                            this.initForm(params.row);
                                            this.modalDisPlay = true;
                                        }
                                    },
                                }, "编辑"));
                            }

                            if (this.permission.isSelectUser) {
                                funcList.push(h('i-button', {
                                    style: {
                                        'margin-right': '5px'
                                    },
                                    attrs: {
                                        type: `error`,
                                        class: "ivu-btn ivu-btn-error ivu-btn-small"
                                    },
                                    on: {
                                        click: (e) => {
                                            this.roleRowId = params.row.id;
                                            this.getSelectedUser(params.row.id);
                                            this.modalUser = true;
                                        }
                                    }
                                }, "人员"));
                            }
                            if (this.permission.isConfigFunc) {
                                funcList.push(h('i-button', {
                                    style: {
                                    },
                                    attrs: {
                                        type: `error`,
                                        class: "ivu-btn ivu-btn-error ivu-btn-small"
                                    },
                                    on: {
                                        click: (e) => {
                                            this.roleRowId = params.row.id;
                                            this.initTreeData(params.row.id);
                                            this.modalFunc = true;
                                        }
                                    }
                                }, "功能项"));
                            }
                            return funcList;
                        }
                    }
                ],
                roleData: [],
                formItem: {
                    id: 0,
                    roleName: '',
                    isUse: true,
                    note: '',
                    creator: parseInt(localStorage.getItem("userId"))
                },
                ruleRole: {
                    roleName: [
                        { required: true, message: '请填写角色名', trigger: 'blur' },
                        { type: 'string', max: 20, message: '输入不得大于20个字', trigger: 'blur' }
                    ],
                    note: [
                        { required: false, message: '', trigger: 'blur' },
                        { type: 'string', max: 50, message: '输入不得大于50个字', trigger: 'blur' }
                    ]
                },
                tableRowIds: [],
                treeData: [],
                selectedUsers: [],
                permission: {
                    isAdd: false,
                    isEdit: false,
                    isDelete: false,
                    isUpdateUse: false,
                    isSelectUser: false,
                    isConfigFunc:false
                }
            }
        },
        methods: {
            initListData(index) {
                let component = this;
                component.searchItems.pageIndex = index;
                request.post('/api/Role/GetRoleList', component.searchItems).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.roleData = response.data.role;
                    component.roleCount = response.data.roleCount;
                }).catch(function (error) {
                })
            },
            initForm(data) {
                this.formItem.id = data.id;
                this.formItem.roleName = data.roleName;
                this.formItem.isUse = data.isUse;
                this.formItem.note = data.note;
                this.formItem.creator = data.creator;
            },
            roleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let component = this;

                        request.post('/api/Role/EditRole', component.formItem).then(function (response) {
                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: '保存失败:' + response.errorMsg
                                });
                                return;
                            }
                            //清空form规则检查
                            component.modalDisPlay = false;
                            component.initListData(1);
                            component.$Notice.success({
                                title: '正确提示',duration: 3,
                                desc: '保存成功!'
                            });

                        }).catch(function (error) {
                        })
                    }
                })
            },
            cancel(name) {
                this.modalDisPlay = false;
                //清空form规则检查
                this.$refs[name].resetFields();
            },
            userItemSubmit() {
                let array = this.$refs.userList.targetKeys;

                let userModel = { role: this.roleRowId, user: array, creator: parseInt(localStorage.getItem("userId")) };

                let component = this;
                request.post('/api/RoleToUser/AddRoleToUser', userModel).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: '保存失败:' + response.errorMsg
                        });
                        return;
                    }

                    component.modalUser = false;
                    component.$Notice.success({
                        title: '正确提示',duration: 3,
                        desc: '保存成功!'
                    });

                }).catch(function (error) {
                })
            },
            menuItemSubmit() {
                let component = this;
                request.post('/api/RoleToFunc/AddRoleToFunc', {
					homeMenus : this.treeData,
					roleId : this.roleRowId
				}).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: '保存失败:' + response.errorMsg
                        });
                        return;
                    }

                    component.modalFunc = false;
                    component.$Notice.success({
                        title: '正确提示',duration: 3,
                        desc: '保存成功!'
                    });
                }).catch(function (error) {
                })
            },
            addRole() {
                this.modalDisPlay = true;
                this.$refs['formRole'].resetFields();
                this.formItem.id = 0;
            },
            roleListSeleChange(items) {
                this.tableRowIds = [];
                for (let i = 0; i < items.length; i++) {
                    this.tableRowIds.push(items[i].id);
                }
            },
            deleteRole() {
                if (this.tableRowIds.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '请选中要删除的角色！'
                    });
                    return;
                }
                let component = this;
                this.$Modal.confirm({
                    title: "操作警告",
                    content: "角色删除后不可恢复，是否继续操作？",
                    onOk() {
                        request.post('/api/Role/DeleRole', component.tableRowIds).then(function (response) {

                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: response.errorMsg
                                });
                                return;
                            }
                            component.initListData(1);
                            component.tableRowIds = [];
                        }).catch(function (error) {
                        })
                    },
                    onCancel() {
                    }
                });
            },
            pageChange(index) {
                this.initListData(index);
            },
            initTreeData(roleId) {
                let component = this;
                request.get('/api/Menu/GetRoleMenu', {
                    params: {
                        roleId: roleId
                    }
                }).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.treeData = response.data;
                }).catch(function (error) {
                })
            },
            getSelectedUser(roleId) {
                let component = this;
                request.get('/api/RoleToUser/GetUserOfRole', {
                    params: {
                        roleId: roleId
                    }
                }).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.selectedUsers = response.data;
                }).catch(function (error) {
                })
            },
            initPermission() {
                let component = this;
                let params = {
                    funcCodes: ['Role.Add','Role.Edit','Role.Delete','Role.UpdateUse','Role.SelectUser','Role.ConfigFunc'],
                    userId: parseInt(localStorage.getItem("userId"))
                };
                request.post('/api/Function/VerifyPermissions', params).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取权限数据失败：" + response.errorMsg
                        });
                        return;
                    }

                    for (var i = 0; i < response.data.length; i++) {
                        
                        switch (response.data[i].funcCode) {
                            case 'Role.Add':
                                component.permission.isAdd = response.data[i].permission
                                break;
                            case 'Role.Edit':
                                component.permission.isEdit = response.data[i].permission
                                break;
                            case 'Role.Delete':
                                component.permission.isDelete = response.data[i].permission
                                break;
                            case 'Role.UpdateUse':
                                component.permission.isUpdateUse = response.data[i].permission
                                break;
                            case 'Role.SelectUser':
                                component.permission.isSelectUser = response.data[i].permission
                                break;
                            case 'Role.ConfigFunc':
                                component.permission.isConfigFunc = response.data[i].permission
                                break;
                        }
                    }
                }).catch(function (error) {
                })
            },
			loopCancelLevel(node) {
				if (node.children) {
					node.children.forEach((item) => {
						this.loopCancelLevel(item)
					})
				}
				if (node.function) {
					node.function.forEach((item) => {
						item.checked = false
					})
				}
				node.checked = false
			},
			loopSelectedLevel(currentNode) {
				this.treeData.forEach((item) => {
					if (item.value == currentNode.pid || item.value == currentNode.menuId) {
						item.checked = true
						return
					}
					item.children.forEach((item2) => {
						if (item2.value == currentNode.pid || item2.value == currentNode.menuId) {
							item2.checked = true
							if (item2.pid > 0) {
								this.loopSelectedLevel(item2)
							}
							return
						}
					})
				})
			},
			firstLevelClick(node) {
				if (node.checked == false) {
					node.children.forEach((item) => {
						this.loopCancelLevel(item)
					})
				}
			},
			secondLevelClick(node) {
				if (node.checked == false) {
					if (node.children) {
						node.children.forEach((item) => {
							this.loopCancelLevel(item)
						})
					}
					if (node.function) {
						node.function.forEach((item) => {
							item.checked = false
						})
					}
				}
				if (node.checked == true) {
					this.loopSelectedLevel(node)
				}
			},
			thirdLevelClick(node) {
				if (node.checked == true) {
					this.loopSelectedLevel(node)
				}
			},
			selectedAll(node){
				if (node.children) {
					node.children.forEach((item) => {
						this.selectedAll(item)
					})
				}
				if (node.function) {
					node.function.forEach((item) => {
						item.checked = true
					})
				}
				node.checked = true
			}
        },
        watch: {
        },
        created: function () {
            this.initListData(1);
            this.initPermission();
        }
    }
</script>

<style scoped>
    .layout {
        background: #fff;
        border-radius: 8px;
        padding: 5px 10px;
    }

    #layout-title {
        overflow: hidden;
        padding: 5px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }

    #box-search {
        padding-top: 20px;
    }

    #layout-title-left {
        float: left;
		display: flex;
		justify-content: center;
		align-items: center;
    }

    #layout-title-right {
        float: right;
    }

    #head-img {
        text-align: center;
        margin-bottom: 20px;
    }

    #head-img-ava {
        cursor: pointer;
    }

        #head-img-ava:hover {
            transform: scale(1.1);
        }

    #page-box {
        margin-top: 20px;
        text-align: center;
    }
	
	.func-modal {
		background-color: white;
		border-radius: 7px;
		padding: 10px;
		margin-bottom: 20px;
	}
	
	.func-modal-title {
		font-size: 16px;
		font-weight: 700;
		overflow: hidden;
	}
	
	.func-modal-title-left{
		float: left;
	}
	
	.func-modal-title-right {
		float: right;
	}
	
	.box{
		margin-top: 15px;
	}
	
	.box-head {
		border-left: 5px solid #0ea391;
		padding-left: 10px;
		overflow: hidden;
	}
	
	.box-head-title {
		float: left;
		font-size: 15px;
		font-weight: 500;
		color: #000000;
	}
	
	.box-body {
		padding: 15px;
		overflow: hidden;
	}
	
	.box-body-item {
		margin-left: 20px;
		margin-right: 20px;
		float: left;
	}
	
	.box-head-title-tool {
		float: right;
	}
	.modal-header{
		display: flex;
		justify-content: left;
		align-items: center;
	}
</style>
